import { addModal } from 'weblite-web-modal-viewer'
import { MediaViewerModal } from './media-viewer-modal'

const COMPONENT_ID = 'mediaViewer'

export const showMediaViewerModal = (
  props: Parameters<typeof MediaViewerModal>[0],
) => addModal({ id: COMPONENT_ID, closeImmediately: true, props })

export default {
  [COMPONENT_ID]: {
    Component: MediaViewerModal,
  },
}
